import { roles } from "./roles.js";
import { status } from "./status.js";
import { nav } from "./nav.js";
import { common } from "./common.js";
import { auth } from "./auth.js";
import { dashboard } from "./dashboard.js";
import { customers } from "./customers.js";
import { catalog } from "./catalog.js";
import { sales } from "./sales.js";
import { jobs } from "./jobs.js";
import { shopFloor } from "./shopFloor.js";
import { inventory } from "./inventory.js";
import { purchasing } from "./purchasing.js";
import { finance } from "./finance.js";
import { reports } from "./reports.js";
import { documents } from "./documents.js";
import { users } from "./users.js";
import { imports } from "./imports.js";
import { audit } from "./audit.js";

export const en = {
  roles,
  status,
  nav,
  common,
  auth,
  dashboard,
  customers,
  catalog,
  sales,
  jobs,
  shopFloor,
  inventory,
  purchasing,
  finance,
  reports,
  documents,
  users,
  imports,
  audit,
};
